import React from 'react';

import styles from './RewardTemplateDetail.module.scss';

const RewardTemplateDetail = ({ icon, title, text, classname }) => (
  <div className={`${styles.rewardContainer} ${classname}`}>
    {icon && <img src={icon} alt="reward" className={styles.rewardIcon} />}
    <div className={styles.detailContainer}>
      <span className={styles.rewardHeading}>{title}</span>
      <span className={styles.rewardText}>{text}</span>
    </div>
  </div>
);

export default RewardTemplateDetail;
